import { render, staticRenderFns } from "./coderInpatientCpts.vue?vue&type=template&id=3070dc56&scoped=true&"
import script from "./coderInpatientCpts.vue?vue&type=script&lang=js&"
export * from "./coderInpatientCpts.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientCpts.vue?vue&type=style&index=0&id=3070dc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070dc56",
  null
  
)

export default component.exports